import GenericTable from 'src/components/GenericTable/GenericTable.vue';
/**
 * This function creates a MenuItem object's ```setCurrentModeParams``` prop that will open a GenericTable component. It takes ```GenericTableProps``` but can take just ```LocalEntityName``` string by way of syntactic sugar.
 */
export default function genericTableInMenuItem(genericTableProps) {
    return {
        setCurrentModeParams: {
            component: GenericTable,
            componentProps: (typeof genericTableProps === 'string') ? { localEntityNameProp: genericTableProps } : genericTableProps
        }
    };
}
